import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'


 import '../scss/custom.scss';
//import 'bootstrap/scss/bootstrap.scss';
// // import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap-vue/src/index.scss';

//import 'bootstrap-vue/dist/bootstrap-vue.css'


// // Bootstrap and its default variables
// import 'bootstrap/scss/bootstrap.scss';
// // BootstrapVue and its default variables
// import 'bootstrap-vue/src/index.scss';

Vue.use(BootstrapVue)
